/*
 *Defining All the API Urls that are being used. 
*/

/**
 * Get Auth URL
 * @return {string} url
 */
export function getAuthUrl(){
    if(window.location.hostname.toLowerCase().indexOf('cor089')<0)
        return "https://"+window.location.hostname.replace('.','-api.')+"/order-status/getToken";
    else
        return "https://orderstatusdev-api.us.parker.corp/order-status/getToken";
}

/**
 * Get Order Url based on type
 * @param {string} type 
 * @param {any} filter 
 * @param {string} filterName 
 * @return {string} url
 */
export function getOrderUrl(type, filter=JSON.parse('{}'), startIndex=1){

    var url = '';
    if(window.location.hostname.toLowerCase().indexOf('cor089')<0)
        url = "https://"+window.location.hostname.replace('.','-api.')+"/order-status/api/v2/administrators/"+type+"/orders?MaximumRecords=-1";
    else
        url = 'https://orderstatusdev-api.us.parker.corp/order-status/api/v2/administrators/'+type+'/orders?MaximumRecords=-1';
    
    if(filter['keyword']!==undefined){
        url = url+'&searchByTerm='+filter['keyword'][0]+'&SearchKeyword='+filter['keyword'][1]
    }
    if(filter['daterange']!==undefined){
        let fromDate = filter['daterange'][0].split('-');
        let toDate = filter['daterange'][1].split('-');
        fromDate = fromDate[2]+fromDate[0]+fromDate[1];
        toDate = toDate[2]+toDate[0]+toDate[1];

        url = url+'&FromDate='+fromDate+'&EndDate='+toDate
    }
    if(filter['orderstatus']!==undefined){
        url = url+'&orderStatus='+filter['orderstatus']
    }
    if(filter['orderplacedwithin']!==undefined){
        url = url+'&duration='+filter['orderplacedwithin']
    }
    return url+'&Start='+startIndex;
}

/**
 * Get Translation Url based on Ids and Locale
 * @param {string} ids //Comman Seperated Ids
 * @param {string} locale 
 * @return {string} url
 */
export function getTranslationUrl(){
    if(window.location.hostname.toLowerCase().indexOf('dev')>-1)
        return "http://previewdev.parker.com/TranslationRestAPI/Translation/getTranslations";
    else if(window.location.hostname.toLowerCase().indexOf('test')>-1)
        return "http://cor089xa006.us.parker.corp:8080/TranslationRestAPI/Translation/getTranslations";
    else
        return "http://previewdev.parker.com/TranslationRestAPI/Translation/getTranslations";
    
}

/**
 * Get Generate Report URL
 * @param {string} duration
 * @return {string} url
 */
export function getGenerateReportUrl(duration=null){
    var url = '';
    if(window.location.hostname.toLowerCase().indexOf('cor089')<0)
        url = "https://"+window.location.hostname.replace('.','-api.')+"/order-status/api/v2/administrators/all/orders/generatereport";
    else
        url = 'https://orderstatusdev-api.us.parker.corp/order-status/api/v2/administrators/all/orders/generatereport';

    if(duration!==null){
        url = url + '?duration='+duration
    }

    return url;
    
}